export default __webpack_public_path__ + "static/media/Bloodseraph's Boots.fb782cc3.jpg";